export const isImageExists = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = url

    if (img.complete) resolve(true)
    else {
      img.onload = () => resolve(true)
      img.onerror = () => reject(false)
    }
  })
}

export default { isImageExists }
